import React from 'react'

import SidePanel from './sidePanel'
import SidePanelTransition from './sidePanel-transition'

import Label from '../../label';
import Page from '../../page/page';
import Button from '../../button/button';

export const closePanel = containerId => {
    console.log('closeSidePanel', containerId, SidePanel.PANELS[containerId]);
    if(!containerId) {
        throw new Error('no \'containerId\' defined !');
    }
    const panelContainer = SidePanel.PANELS[containerId]
    if(!panelContainer) {
        throw new Error('no sidepanel with this \'containerId\' existe !', containerId);
    }
    return panelContainer.close;
}

const open_panel = (containerId, data, className=false) => {
    console.log('open_panel data', data)
    console.log('open_panel className', className)
    console.log('open_panel containerId', containerId)
    console.log('open_panel SidePanel.PANELS', SidePanel)

    if(!containerId) {
        throw new Error('no \'containerId\' defined !');
    }
    const panelContainer = SidePanel.PANELS[containerId]
    if(!panelContainer) {
        console.error('no sidepanel with <containerId="' + containerId + '">   existe !');
        return
    }
    panelContainer.close();
    setTimeout(() => panelContainer.setState({data, className, close: panelContainer.close}), SidePanelTransition.TRANSITION_TIME)
}

export const openPanel = (panelId, {type, attrs}, className) => (
    new Promise((resolve, reject) => {
        const submit = {resolve, reject}
        open_panel(panelId, {type, attrs: {...attrs, submit}}, className)
    })
)


const openPanelWithSelection = (panelId, objectClassName, objectParams, nodeClassName, title='none') => {
    let resolver;
    let rejecter;
    const promise = new Promise((resolve, reject) => {
        resolver=resolve
        rejecter=reject
    })
    promise.then(closeSidePanel(panelId), closeSidePanel(panelId))
    const header = <Label>{title}</Label>
    const footer = <div className="buttons">
        <Button label={'app.select'} onClick={e => resolver() } />
        <Button label={'app.cancel'} onClick={e => rejecter() } />
    </div>

    return new Promise((resolve, reject) => {
        const body = React.createElement(objectClassName, {promise, ...objectParams, submit: {resolve, reject}})
        open_panel(panelId, {type: Page, attrs:{ header, body, footer }}, nodeClassName)
    })
}

/* FIXME: not working*/
export const openPanelPage = (panelId, objectClassName, objectParams, title='', nodeClassName) => {
    let resolver;
    let rejecter;
    const promise = new Promise((resolve, reject) => {
        resolver=resolve
        rejecter=reject
    })
    promise.then(closeSidePanel(panelId), closeSidePanel(panelId))
    const header = <Label>{title}</Label>
    const footer = <div className="buttons">
        <Button label={'app.cancel'} onClick={e => rejecter() } />
    </div>

    return new Promise((resolve, reject) => {
        const body = React.createElement(objectClassName, {...objectParams, submit: {resolve, reject}})
        open_panel(panelId, {type: Page, attrs:{ header, body, footer }}, nodeClassName)
    })
}

// ajout de params/ voir ou className n'a pas ete mit
export const openPanelSimple = (panelId, objectClassName, objectParams, nodeClassName) => {
    return openPanel(panelId, {type: objectClassName, attrs: objectParams}, nodeClassName)
}

// ajout de params/ voir ou className n'a pas ete mit
export const openPanelSelect = (panelId, objectClassName, objectParams, nodeClassName, title) => {
    return openPanelWithSelection(panelId, objectClassName, objectParams, nodeClassName, title)
}

// @deprecated  should be removed
export const openPanelSelectMultiple = (panelId, objectClassName, objectParams, nodeClassName, title) => {
    return openPanelWithSelection(panelId, objectClassName, {...objectParams, multiple: true}, nodeClassName, title)
}

/**
 * @deprecated since version 2.1.2
 */
export const openSidePanel = openPanel
/**
 * @deprecated since version 2.1.2
 */
export const openSidePanelPage = openPanelPage
/**
 * @deprecated since version 2.1.2
 */
export const openSidePanelSelecting = openPanelSelect
/**
 * @deprecated since version 2.1.2
 */
export const openSidePanelSelectingMultiple = openPanelSelectMultiple
/**
 * @deprecated since version 2.1.2
 */
export const closeSidePanel = closePanel
